// playerUtils.ts - Helper functions for audio player
import { PlayerTrack } from '@/types/track_types';

// formatTime은 @/utils/audioPlayerUtils에서 import하여 사용하세요
export { formatTime } from '@/utils/audioPlayerUtils';

/**
 * 구매 버튼 상태 계산
 * 트랙 상태에 따라 버튼 표시 여부 및 텍스트 반환
 */
export const getButtonState = (
  currentTrack: PlayerTrack | null,
): { show: boolean; text: string } => {
  if (!currentTrack) {
    return { show: false, text: '' };
  }

  const { status, isPurchased, isInCart } = currentTrack;

  // PURCHASED 상태이거나 구매 완료된 경우 버튼 숨김
  if (status === 'PURCHASED' || isPurchased || isInCart) {
    return { show: false, text: '' };
  }

  // status가 없는 경우 기본 Buy 버튼
  if (!status) {
    return { show: true, text: 'Buy' };
  }

  // 구매 가능 상태만 버튼 표시
  if (status === 'ONSALE' || status === 'ACTIVE') {
    return { show: true, text: 'Buy' };
  }

  // 그 외 모든 상태는 버튼 숨김 (SCHEDULED, ENDED, SOLDOUT, CANCELLED 등)
  return { show: false, text: '' };
};

/**
 * 프로그레스 바 클릭/드래그 시 시간 계산
 */
export const calculateTimeFromPosition = (
  clientX: number,
  rect: DOMRect,
  duration: number,
): number => {
  const percent = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
  return percent * duration;
};

/**
 * 볼륨 바 클릭/드래그 시 볼륨 계산
 */
export const calculateVolumeFromPosition = (clientX: number, rect: DOMRect): number => {
  return Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
};
